export const platformTips: Record<string, JSX.Element> = {
  Facebook: (
    <>
      <p className="mb-2">
        You can choose a Daily or Weekly schedule and specify 1–3 posts per day
        per listing. This will maintain steady engagement on Facebook.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Emojis:</strong> Use emojis to convey
        tone and highlight important details.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Price:</strong> Include the listing
        price to offer clear value context to your audience.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Sold Post:</strong> Enable this option
        to automatically publish a formal sold announcement when the listing
        closes.
      </p>
    </>
  ),

  Instagram: (
    <>
      <p className="mb-2">
        You can choose a maximum of 3 posts per week. This approach will ensure
        consistent visual presence on Instagram and help prevent your posts from
        being flagged as spam, reducing the risk of account suspension.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Emojis:</strong> Use emojis to enhance
        expressiveness and encourage engagement.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Price:</strong> Include the listing
        price to provide clear pricing information without overwhelming the
        caption.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Sold Post:</strong> Enable this option
        to automatically share a concise sold announcement once the transaction
        is complete.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Avoid:</strong> Avoid including links
        to external sites in your captions, as Instagram limits clickable links
        to the bio section. Avoid phone numbers as they can trigger spam
        filters.
      </p>
    </>
  ),

  Twitter: (
    <>
      <p className="mb-2">
        You can choose a Daily or Weekly schedule and specify 1–3 posts per day
        per listing. This will help maintain visibility in fast-moving feeds.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Emojis:</strong> Use emojis to add
        personality and emphasize key points.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Price:</strong> Include the price to
        immediately inform potential buyers of the offer.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Sold Post:</strong> Enable this option
        to automatically publish a formal sold post when the listing closes.
      </p>
    </>
  ),

  LinkedIn: (
    <>
      <p className="mb-2">
        You can choose a Daily or Weekly schedule and specify 1–3 posts per day
        per listing. This will ensure professional consistency on LinkedIn.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Emojis:</strong> Use emojis to maintain
        a professional tone while enhancing readability.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Price:</strong> Include the listing
        price to convey transparency and credibility.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Sold Post:</strong> Enable this option
        to automatically share a polished sold announcement with your
        professional network.
      </p>
    </>
  ),

  Pinterest: (
    <>
      <p className="mb-2">
        You can choose a Daily or Weekly schedule and specify 1–3 pins per day
        per listing. This will ensure each listing image gets adequate exposure.
      </p>
      <p className="mb-2">
        Posting stops to pinterest automatically after all images from listing
        are posted. If more images are added to the listing, new posts will be
        created automatically during campaign renewal.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Emojis:</strong> Use emojis to add a
        visual cue and draw attention to your pins.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Price:</strong> Include the listing
        price to inform potential buyers directly from the pin.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Sold Post:</strong> Enable this option
        to automatically publish a final sold pin when the listing closes.
      </p>
      <p className="mb-2">
        When adding custom posts, make sure to add unique images to enhance
        engagement and avoid duplication.
      </p>
    </>
  ),

  Google: (
    <>
      <p className="mb-2">
        Marabot will publish an introductory (new listing) post immediately when
        the campaign is created (based on campagn start date), announcing your
        new property.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Open House:</strong> You can create and
        schedule Open House posts from listing page.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Sold Post:</strong> If enabled, Marabot
        will publish a sold announcement post once the listing status changes to
        closed.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Emojis:</strong> Use emojis to draw
        attention without compromising professionalism.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Price:</strong> Include the listing
        price to provide clear cost information and set accurate expectations.
      </p>
      <p className="mb-2 text-red-600">
        <strong className="text-primary">Important: </strong>
        Posts must not include phone numbers, as this may result in content
        being flagged or blocked by Google.
      </p>
    </>
  ),
  YouTube: (
    <>
      <p className="mb-2">
        You can choose a Daily or Weekly schedule and specify 1–3 posts per day
        per listing. This helps maintain consistent visibility and engagement on
        YouTube.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Video Visibility:</strong> Set your
        YouTube video as <strong>Public</strong> or <strong>Private</strong> by
        default to control when the video becomes visible to viewers.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Notify Subscribers:</strong> Enable
        notifications to alert your subscribers when a new video is published,
        helping increase early engagement.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Emojis:</strong> Use emojis in video
        titles or descriptions to make the content more engaging and visually
        appealing.
      </p>
      <p className="mb-2">
        <strong className="text-primary">Price:</strong> Include the listing
        price in the video description to give viewers clear value context about
        the property.
      </p>
    </>
  ),
};
